<template>
  <div class="c-table pb-4">
    <table class="c-table__table">
      <tr v-if="header && header.length > 0">
        <th
          v-for="(name, index) in header"
          :key="index"
        >
          {{ name }}
        </th>
      </tr>
      <template v-if="propList">
        <tr
          v-for="(item, key) in propList"
          :key="key"
        >
          <template v-if="header && header.length > 0">
            <td
              v-for="(name, index) in header"
              :key="index"
            >
              {{ item?.[index] || '&nbsp;' }}
            </td>
          </template>
          <template v-else>
            <td
              v-for="value in item"
              :key="value"
            >
              {{ value }}
            </td>
          </template>
        </tr>
      </template>
    </table>
    <div v-if="limit && propList" class="c-table__limit">
      <div class="c-table__limit__info">{{ text }}</div>
      <c-button
        v-if="length < list?.length"
        :text="translations.next"
        color="primary"
        @click="onNext"
      />
    </div>
  </div>
</template>

<script>
import CButton from '@/components/CButton'
import { props } from '@/components/CTable/props'
import Translation from 'dcode/classes/Translation'
import { computed, ref } from 'vue'

export default {
  name: 'CTable',
  components: { CButton },
  props,
  setup (props) {
    const translations = Translation.getByList(['next', 'table-limit'])
    const page = ref(1)
    const length = computed(() => {
      const max = page.value * props.limit

      return max > props.list.length ? props.list.length : max
    })

    const propList = computed(() => {
      if (props.limit) {
        return [...props.list].slice(0, props.limit * page.value)
      } else {
        return props.list
      }
    })

    return {
      propList,
      length,

      onNext () {
        page.value++
      },

      translations,
      text: computed(() => {
        return translations['table-limit']
          .toString()
          .replace('[page]', length.value.toString())
          .replace('[limit]', props.list.length.toString())
      })
    }
  }
}
</script>

<style lang="scss">
.c-table {
  &__table {
    min-width: 100%;

    tr {
      @apply hover:bg-gray-100;

      + tr {
        @apply border-t;
      }
    }

    th {
      @apply font-sans text-xs font-medium uppercase px-2 py-4;
      @apply text-gray-900 ltr:text-left rtl:text-right;
    }

    td {
      @apply font-sans text-sm font-medium px-2 py-4;
    }
  }

  &__limit {
    @apply flex flex-col items-center p-4 rounded-b-lg;
    background: #FBFBFD;

    &__info {
      @apply font-sans text-xs font-medium pb-2;
      color: #9CA3AF;
    }
  }
}
</style>
